import { AiOutlineLoading } from "react-icons/ai";

const LoadingIcon = () => {
  return <AiOutlineLoading className="z-30 animate-spin text-4xl text-white" />;
};
export default LoadingIcon;
